if ($(".js_array_creation_listener")[0]) {

    $(".js_array_creation_listener").each(function () {
        if ($(this).val()) {
            for (const element of JSON.parse("[" + $(this).val() + "]")[0]) {

                $("#" + $(this).data("array_from") + " option[value=" + element + "]").prop("selected", true)
            }
        }

        $(document).on('change', "#" + $(this).data("array_from"), function() {
            var string = []

            for (const elem of $(this).val()) {
                string.push("\"" + elem + "\"");
            }
            $("#" + $(this).data("connected_to")).val("[" + string.toString() + "]");
        });
    });
}

if ($('#select_all')[0]) {
    $("#select_all").on("click", function () {
        if ($("#select_all").is(":checked")) {
            $('#checkbox_table .js_checkbox').prop("checked", true);
        } else {
            $('#checkbox_table .js_checkbox').prop("checked", false);
        }
    });
}